export default {
    actions: {
        loadFeeds(store, {params}) {
            return this.dispatch('sendRequest', { path: '/feed', params, method: 'get', formErrors: {} });
        }
    }
}